// ══════════════════════════════════════════════════════════════════════
// WeConnect CRM — Constantes compartidas
// ══════════════════════════════════════════════════════════════════════
// Fuente única de verdad para valores que se usan en más de un archivo.
// Antes vivían duplicados en App.js y ContextPanel.jsx.

// ── Etapas y estados de cada área ────────────────────────────────────

export const ETAPAS_VENTAS = [
  'Lead nuevo',
  'Contactado',
  'Calificado',
  'Cobertura validada',
  'Propuesta enviada',
  'Seguimiento',
  'Aceptó oferta',
  'Venta confirmada',
  'Venta perdida',
  'Sin cobertura expansión',
];

export const ESTADOS_ATENCION = [
  'Pendiente de revisión',
  'Esperando cliente',
  'Esperando pago',
  'Factura enviada',
  'Resuelto',
];

export const ESTADOS_SOPORTE = [
  'Pendiente de revisión',
  'Diagnóstico en curso',
  'Esperando cliente',
  'Derivado a visita técnica',
  'Resuelto',
];

// ── Estados que cuentan como "conversación activa" ───────────────────

export const ESTADOS_ACTIVOS = ['abierta', 'en_curso', 'activa', 'pendiente', 'escalada', 'pendiente_instalacion', 'venta_confirmada'];

// ── Keys de localStorage ─────────────────────────────────────────────

export const VENTAS_STORAGE_KEY = 'weconnect_ventas_local_data_v2';
export const ATENCION_STORAGE_KEY = 'weconnect_atencion_local_data_v1';
export const SOPORTE_STORAGE_KEY = 'weconnect_soporte_local_data_v1';

// ── Estructura inicial de un resumen de venta ────────────────────────

export const DEFAULT_SALES_SUMMARY = {
  nombre_apellido: '',
  cuil: '',
  email: '',
  direccion: '',
  entre_calle_1: '',
  entre_calle_2: '',
  localidad: '',
  telefono: '',
  plan: '',
  precio: '',
  medio_pago: '',
  latitud: '',
  longitud: '',
  mapa_url: '',
  observaciones: '',
};

// ── Usuarios demo para testing de permisos ───────────────────────────

export const DEMO_USERS = [
  {
    id: 'admin-general',
    nombre: 'Admin General',
    nivel: 'admin',
    areas: ['ventas', 'atencion', 'soporte'],
  },
  {
    id: 'agente-comercial',
    nombre: 'Agente Ventas + Atención',
    nivel: 'agente',
    areas: ['ventas', 'atencion'],
  },
  {
    id: 'agente-soporte',
    nombre: 'Agente Soporte',
    nivel: 'agente',
    areas: ['soporte'],
  },
  {
    id: 'nocturno',
    nombre: 'Nocturno Full',
    nivel: 'agente',
    areas: ['ventas', 'atencion', 'soporte'],
  },
];

// ── Localidades de referencia para la zona de cobertura ──────────────

export const LOCALIDADES_REFERENCIA = [
  'almirante brown',
  'burzaco',
  'adrogue',
  'adrogué',
  'longchamps',
  'longchamp',
  'glew',
  'claypole',
  'jose marmol',
  'josé mármol',
  'rafael calzada',
  'san jose',
  'san josé',
  'florencio varela',
  'bosques',
  'ingeniero allan',
  'villa vatteone',
  'villa brown',
  'capitan sarmiento',
  'capitán sarmiento',
  'pablo podesta',
  'pablo podestá',
];

// ── Localidades en expansión ─────────────────────────────────────────

export const LOCALIDADES_EXPANSION = ['Capitán Sarmiento', 'Florencio Varela', 'Almirante Brown'];

// ── Palabras que descartan una línea como dirección ──────────────────

export const PALABRAS_NO_DIRECCION = [
  'gamer',
  'gaming',
  'streaming',
  'trabajo remoto',
  'uso general',
  'mercadopago',
  'mercado pago',
  'tarjeta',
  'transferencia',
  'pago facil',
  'pago fácil',
  'quiero',
  'me interesa',
  'megas',
  'mb',
  'mbps',
  '300',
  '600',
  '100',
];

// ── Frases que NO son nombres (confirmaciones, saludos) ──────────────

export const FRASES_NO_NOMBRE = [
  'todo correcto', 'todo bien', 'todo perfecto', 'esta todo correcto',
  'esta bien', 'esta perfecto', 'esta todo bien', 'correcto todo',
  'todo ok', 'todo ok gracias', 'gracias', 'muchas gracias', 'ok gracias',
  'si gracias', 'no gracias', 'listo', 'dale', 'bueno', 'buenas',
  'hola', 'buen dia', 'buenos dias', 'buenas tardes', 'buenas noches',
  'correcto', 'confirmado', 'confirmo', 'perfecto', 'esta perfecto',
  'muy bien', 'esta muy bien', 'asi es', 'exacto', 'nada mas',
  'nada gracias', 'esta bien gracias', 'ok', 'okay',
];

// ── Títulos de modales de ventas ─────────────────────────────────────

export const MODAL_TITLES = {
  contactar: 'Marcar contacto realizado',
  calificar: 'Calificar lead',
  cobertura: 'Validar cobertura',
  propuesta: 'Enviar propuesta',
  seguimiento: 'Programar seguimiento',
  aceptar: 'Registrar aceptación',
  perdida: 'Marcar venta perdida',
  confirmar: 'Revisar y confirmar venta',
};

// ── Colores por área (usados en Inbox y otros) ───────────────────────

export const AREA_COLORS = {
  ventas: '#22c55e',
  atencion: '#3b82f6',
  soporte: '#f59e0b',
  marketing: '#8b5cf6',
};

// ── URL base de la API ───────────────────────────────────────────────

export const API_URL = process.env.REACT_APP_API_URL || '';
